import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useMeasurementStatuses = defineStore('measurement-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.measurementStatus_ListMeasurementStatuses,
    dto: 'MeasurementStatusDto',
    create: api.measurementStatus_CreateMeasurementStatus,
    update: api.measurementStatus_UpdateMeasurementStatus,
    delete: api.measurementStatus_DeleteMeasurementStatus,
    usage: api.measurementStatus_GetUsage,
    signalR: 'MeasurementStatusUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
